<template>
  <div>
    <el-header :class="isCollapse ? 'header' : 'headerno'" style="height: 50px;line-height: 50px;color: #28649A;" ></el-header>
    <!-- 安全管理平台 -->
 <el-aside :width="isCollapse ? '4rem' : '13.125rem'">
     <el-menu background-color="#fff" text-color="#333" active-text-color="#E9E9EB" class="el-menu-vertical-demo"
        :default-active="'$route'" :collapse="isCollapse" :collapse-transition="false" @select="handleSelect"
        @open="handleOpen" @close="handleClose">
        <NavMenu :navMenus="totalList"></NavMenu>
      </el-menu>
    </el-aside>
  </div>
</template>

<script>
  import config from "../router/config";
  import NavMenu from "./Menulist";
  import {
    mapState
  } from 'vuex';
  export default {
    computed: {
      ...mapState({
        current: state => state.tab.currentMenu,
      }),
      isCollapse() {
        return this.$store.state.tab.isCollapse
      }
    },
    data() {
      return {
        userImg: require('../assets/img/20220127001.jpg'),
        circleUrl: "https://cube.elemecdn.com/3/7c/3ea6beec64369c2642b92c6726f1epng.png",
        totalList: [],

      }
    },
    methods: {
      handleOpen(key, keyPath) {
        // console.log(key, 'aasasasas');
        //  console.log(keyPath, 'aasasasas');
      },
      handleClose(key, keyPath) {
        // console.log(key, keyPath);
      },
      handleSelect(key, keyPath) {
        // console.log(key,'key')
        //  console.log(keyPath,'keypath')
        this.$router.push({
          path: key,
          params: {
            data: 'query'
          }
        })
      },
      // 获取动态路由
      getRoute() {
        var that = this
        var data = {
          'id': localStorage.getItem('id'),
          'bm_type': localStorage.getItem('DeptType'),
        }
        this.$axios({
          method: 'post',
          url: '/apiadmin/Login/loginTrees',
          headers: {
            'Authorization': 'ZhiHuiWanLian1.0'
          },
          data: data,
        }).then(function(response) {
          that.totalList = response.data.data.list
          console.log('sjsiqnxianzzajisiwomn uzhdiawosjemhhdaiohaodhdidjweishemn woe buzhida ')
        })
      }
    },
    components: {
      NavMenu
    },
    created() {
      this.getRoute()
      // this.totalList = config
    },

  }
</script>
<style scoped>
  @import "../assets/css/index.less";

  ::-webkit-scrollbar {
    display: none
  }










</style>



// WEBPACK FOOTER //
// src/components/Sidebar.vue